import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, finalize, retry, throwError } from 'rxjs';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { TokenService } from '../service/token.service';
import { NotificationsService } from '@/shared/notifications/notifications.service';
import { LoaderService } from '@/shared/components/loader/services/loader.service';

let tratando403 = false;

export const backendTokenInterceptor: HttpInterceptorFn = (req, next: HttpHandlerFn) => {
  const tokenService = inject(TokenService);
  const notificationsService = inject(NotificationsService);
  const loader = inject(LoaderService);
  const router = inject(Router);
  const location = inject(Location);

  //if (!req.url.includes('/api/maxline/eventos')) {
    loader.show();
//  }
const isHelpRequest = req.url.includes('assets/help')
  if (tokenService.hasToken() && !isHelpRequest) {
    const token = tokenService.getToken();
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Accept-Language': 'pt-BR',
      },
    });
  }

  return next(req).pipe(
    retry(0),

    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        tokenService.removeToken();
        const currentUrl = router.url;
        let returnUrl: string | undefined;
        if (currentUrl && !currentUrl.startsWith('/login')) {
          returnUrl = currentUrl;
        }
        router.navigate(['/login'], returnUrl ? { queryParams: { returnUrl } } : {});
        return throwError(() => error);
      }

      if (error.status === 403) {
        if (!tratando403) {
          tratando403 = true;
          notificationsService.toastNotify(
            'warn',
            'Acesso negado',
            'Você não possui permissão para acessar esta tela.'
          );
          if (router.navigated) {
            location.back();
          } else {
            router.navigate(['/']);
          }
          setTimeout(() => {
            tratando403 = false;
          }, 1500);
        }
        return throwError(() => error);
      }

      if (error.status !== 404 && error.status !== 409) {
        if (!error.error) {
          notificationsService.toastNotify('error', error.statusText, error.message);
        } else if (error.error.objects) {
          console.error(error.error);
          notificationsService.toastNotify(
            'error',
            error.error.title,
            error.error.objects[0].userMessage
          );
        } else if (error.error.detail) {
          console.error(error.error);
          notificationsService.toastNotify('error', error.error.title, error.error.detail);
        } else if (error.error.mensagemRetorno) {
          // Padrão `Retorno` (StatusRetorno/MensagemRetorno) usado pelas APIs v3.
          console.error(error.error);
          const severidade = error.status === 400 ? 'warn' : 'error';
          const titulo = error.status === 400 ? 'Atenção' : 'Erro!';
          notificationsService.toastNotify(severidade, titulo, error.error.mensagemRetorno);
        } else {
          console.error(error.error);
          const msg =
            typeof error.error === 'string'
              ? error.error
              : `${error.message}: ${error.status}`;
          notificationsService.toastNotify('error', 'Erro!', msg);
        }
      }

      return throwError(() => error);
    }),


    finalize(() => {
        loader.hide()
        //console.log(req.url);
    })
  );
};
